$(document).ready(function() {

    new Swiper('.swiper', {
        slidesPerView: 1,
        runCallbacksOnInit: true,
        observer: true,
        scrollbarHide:true,
        updateOnImagesReady: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletActiveClass: 'swiper-pagination-bullet-active bg-white !opacity-100',
            bulletClass: 'swiper-pagination-bullet bg-white opacity-50'
        },
        on: {
            slideChange: function () {
                if(typeof window.dataLayer !== "undefined" && window.dataLayer !== null) {
                    gtag('event', 'collection_product_slider_change', { 
                        event_category: 'click',
                        event_label: 'CollectionSliderChange - ProductImages - ' + window.location.pathname
                    });
                }
            }
        }
    });

    $('#inline__filters .filter__item .filter__item__button').on('click', function(e) {

        e.stopPropagation();

        var itemFilter = $(this).parents('.filter__item');
        var itemList = itemFilter.find('.filter__item__list');

        if(itemList.hasClass('hidden')) {
            $('.filter__item__list').addClass('hidden');
            itemList.toggleClass('hidden');
        } else {
            itemList.toggleClass('hidden');
        }
    
    });

    $(document).on('click', function(e) {
        $('#inline__filters .filter__item__list').addClass('hidden');
    });

    $('#inline__filters .filter__item__list').on('click', function(e) {
        e.stopPropagation();
    });

    $('#inline__filters .remove-filter').on('click', function(e) {

        if(document.location.search === "") {
            
            e.preventDefault();
            
            var href = document.location.href;
            var regex = /\-\d+x\d+$/;
    
            if(regex.test(href)) {
                href = href.replace(regex, "");
                document.location.href = href;
            }

        }

    });

    $('#inline__filters input[name^="filter."], #inline__filters input[name="sort_by"]').on('change', function() {

        var href = document.location.href.replace(document.location.search, '');
        var regex = /\-\d+x\d+$/;

        if(regex.test(href)) {
            href = href.replace(regex, "");
        }
        
        var url = new URL(href);

        $('#inline__filters input[name^="filter."]:checked, #inline__filters input[name="sort_by"]:checked').each( function(i, e) {
            url.searchParams.append($(e).attr('name'), $(e).val());
        });
         
        document.location.href = url.toString();

    });

    $('#popup__filters .popup__filters__reset').on('click', function() {
        $('#popup__filters input[type="checkbox"]').prop('checked', false);
        $('#popup__filters input[type="number"], #popup__filters input[type="text"]').val('');
    });

    $('#popup__filters .popup__filters__save').on('click', function() {
        
        var url = new URL(document.location.origin + document.location.pathname);

        $('#popup__filters input:checked, #popup__filters input[type="number"], #popup__filters input[type="text"]').each(function(e) {
            if($(this).val() !== "") {
                url.searchParams.append($(this).attr('name'), $(this).val());
            }
        });

        document.location.href = url.toString();

    });

    $('.filters__show').on('click', function() {

        $('body').addClass('overflow-hidden').removeClass('overflow-y-auto');
        $('#popup__filters #filtersBackdrop').removeClass('opacity-0').addClass('opacity-100');
        $('#popup__filters #filtersContainer').removeClass('translate-x-full').addClass('translate-x-0');

        $('#popup__filters').removeClass('hidden');
        $('#popup__filters').attr('aria-hidden', false);
        $('main').attr('aria-hidden', true);

        if(typeof $("#popup__filters").attr('aria-expanded') !== "undefined") {
            $("#popup__filters").attr('aria-expanded', true);
        }

    });

    $('#popup__filters .popup__filters__close').on('click', function() {

        $('#popup__filters #filtersContainer').removeClass('translate-x-0').addClass('translate-x-full');
        $('#popup__filters #filtersBackdrop').removeClass('opacity-100').addClass('opacity-0');

        setTimeout(function() {
            $('#popup__filters').addClass('hidden');
            $('#popup__filters').attr('aria-hidden', true);
            $('main').attr('aria-hidden', false);
            $('#popup__filters [data-modal][aria-expanded="true"]').attr('aria-expanded', false);
            
            $('body').removeClass('overflow-hidden').addClass('overflow-y-auto');
            modalTriggeredBy.focus();

        }, 300);

    });

    $('.accordion .accordion__header').on('click', function() {

        var accordion        = $(this).parents('.accordion');
        var accordionItem    = $(this).parents('.accordion__item');
        var accordionContent = accordionItem.find('.accordion__content');

        if(accordionContent.hasClass('hidden')) {
            accordion.find('.accordion__content').addClass('hidden');
            accordionContent.toggleClass('hidden');
        } else {
            accordionContent.toggleClass('hidden');
        }

    });

});